<app-header [menuList$]="menuList$" [memberInfo$]="memberInfo$"></app-header>

<app-sub-header [currMenu]="currMenu$" [memberInfo]="memberInfo$"></app-sub-header>

<!-- 서브메뉴 탭 구성 //-->
<ng-container *ngIf="(currMenu$ | async)['page_cd'].length > 6 && (currMenu$ | async)['parentNode']['children'].length > 0">
  <ul class="sub-tab inner-wrap">
    <li class="nav-item" *ngFor="let item of (currMenu$ | async)['parentNode']['children']; index as i">
      <a class="cp nav-link" [ngClass]="{active: (currMenu$ | async)['seq'] == item.seq}" (click)="goLink(item)">{{item.page_menu_name}}</a>
    </li>
  </ul>
</ng-container>

<div class="board-view inner-wrap">
 <div class="sns fr">
   <!--a href="https://www.facebook.com/hvacr.kraia" target="_blank"//-->

   <!-- <div class="fb-share-button"
      data-href="http://localhost:4200/board/view?board_id=notice&board_seq=14497"
      data-layout="button_count">
    </div> -->

  <!-- <div class="fb-share-button" data-layout="button"></div> -->

  <!-- <a class="fb-share-button" data-href="{{currentURL}}" data-layout="button"></a> -->

  <a (click)="facebookShare()" style="cursor:pointer">
    <img src="/assets/images/icon_facebook.png" alt="facebook" />
  </a>

   <a (click)="twitterShare()" style="cursor:pointer">
     <img src="/assets/images/icon_twitter.png" alt="twitter" />
   </a>
 </div>

 <div class="cb"></div>

  <table>
  <colgroup>
    <col class="col1">
    <col class="col2">
  </colgroup>

  <tbody>
  <tr class="title">
    <td colspan="2">
      <ng-container *ngIf="data['detail'] != undefined">
      {{data['detail'].subject}}
      </ng-container>
    </td>
  </tr>

  <ng-container *ngIf="data.detail.board_id == 'certification' || data.detail.board_id == 'ahriqna'">
    <tr *ngIf="data.detail.board_id == 'ahriqna'" class="tr-ul">
      <td colspan="2" class="td-ul">
        <ul>
          <li>
            <p class="th">구분</p>
            <p class="td">{{data.detail.group_id}}</p>
          </li>
          <li><p class="td" style="width: 100%;"></p></li>
        </ul>
      </td>
    </tr>
    <tr class="tr-ul">
      <td colspan="2" class="td-ul">
        <ul>
          <li>
            <p class="th">등록자</p>
            <p class="td">{{data.detail.writer_name}}</p>
          </li>
          <li><p class="td" style="width: 100%;"></p></li>
        </ul>
      </td>
    </tr>
  </ng-container>

  <tr class="info">
    <td colspan="2">
      <div *ngIf="data['detail'] != undefined">{{data['detail'].write_date}}</div>
      <div *ngIf="data['detail'] != undefined">조회 {{data['detail'].hit}}</div>
    </td>
  </tr>

  <tr class="contents">
    <td colspan="2">
      <ng-container *ngIf="data['detail'] != undefined" >
      <div [innerHTML]="data['detail'].contents | safe: 'html'"></div>
      </ng-container>
    </td>
  </tr>
  <ng-container *ngIf="data['detail'] != undefined">
  <tr class="append-file" *ngIf="data['upload'].length > 0">
    <th>첨부파일</th>
    <td>
      <ul>
        <ng-container *ngFor="let item of data['upload']">
        <li *ngIf="( boardInfo.upload_image_down == false && item.file_type !== 'IMAGE' ) || boardInfo.upload_image_down == true">
          <a href="{{item.url.replace('http:', '')}}" target="_blank">{{item.origin}}</a>
        </li>
        </ng-container>
      </ul>
    </td>
  </tr>
  </ng-container>
  </tbody>
  </table>

  <div>
    <button class="list-btn" (click)="list()">목록</button>
    <span style="margin-left: 10px;"></span>
    <ng-container *ngIf="authEditCheck( data.detail.writer )">
      <button class="edit-btn" (click)="modify()">수정</button>
      <span style="margin-left: 10px;"></span>
      <button class="edit-btn" (click)="deletePost()">삭제</button>
    </ng-container>
    <ng-container *ngIf='authReplyCheck()'>
      <div class="fr">
        <button class="edit-btn" (click)="reply()">답변쓰기</button>
      </div>
    </ng-container>

  </div>
</div>

<app-footer></app-footer>
